export default "/images/5e8b187b12b88cadb7e8c40393457bc5.avif";